<style lang="stylus">
    .tpl-preview
        position fixed
        top 0
        left 0
        right 0
        bottom 0
        z-index 1000
        background #ffffff
        user-select none
        &.pc-collection
            left 180px

        .grab-cursor{
            cursor: -webkit-grab !important;
            cursor: grab !important;
        }
        .grabing-cursor{
            cursor: -webkit-grabbing !important;
            cursor: grabbing !important;
        }
        .tpl-preview-mask
            z-index 1
            width 100%;
            height 100%;
            position relative
            img
                position absolute
                top 50%
                left 50%
                transform translate(-50%, -50%)

        .tpl-preview-loading
            position fixed
            top 60px
            bottom 0
            left 0
            right 0
            z-index 888
            background #fff
            display flex
            align-items center
            justify-content center

        .tpl-preview-header
            height 60px
            background #fff
            display flex
            align-items center
            color black

            .tpl-return
                width 60px
                padding 0 10px
                height 100%
                display flex
                justify-content center
                align-items center
                flex-shrink 0
                cursor pointer
                &:hover
                    svg
                        fill #017fff
                svg
                    width 24px
                    height 24px
                    fill #424242

            .tpl-leftHeaderbox
                height 60px
                display flex
                align-items center
                margin-right auto
                .work-title
                    margin-right auto
                    font-size 18px
                    flex 0 0 500px
                    box-sizing border-box
                    max-width 500px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap

            .work-spread
                width 24px
                height 24px
                cursor pointer
                fill #424242
                margin-right 30px

            .work-zoom-box
                display flex
                flex 1 1 auto
                align-items center

                .work-zoom-info
                    user-select none
                    font-size 18px
                    margin 0 10px

                svg
                    width 24px
                    height 24px
                    fill #424242
                    stroke #424242
                    cursor pointer

            .work-ope-box
                display flex
                justify-content space-between
                align-items center
                flex 0 0 auto
                white-space nowrap

                .ope-button
                    background-color var(--themeColor)
                    border-radius 3px
                    margin-right 20px
                    height 34px
                    color white
                    font-size 14px
                    padding 0 16px
                    line-height 34px
                    cursor pointer
                    .ivu-tooltip-rel
                        display inline-flex
                        align-items center
                        justify-content center
                        .source-vip-icon
                            width 18px
                            height 18px
                            margin-right 5px
                .ope-fill-item
                    svg
                        cursor pointer
                        &:hover
                            fill-opacity 0.2 !important
                    &.opei-done
                        svg
                            fill-opacity 0.2 !important
                .ope-ex-item
                    svg
                        fill #424242 !important
                        stroke none
                .ope-share-item
                    display flex
                    height 24px
                    line-height 24px
                    margin-right 30px
                    svg
                        width 24px
                        height 24px
                    .ope-share-item-black
                        display block
                    .ope-share-item-blue
                        display none
                    &:hover
                        .ope-share-item-black
                            display none
                        .ope-share-item-blue
                            display block
                    .ope-item-text
                        margin-left 6px
                        font-size 14px

                .ope-item
                    display flex
                    height 24px
                    line-height 24px
                    margin-right 30px
                    &.disabled-icon
                        svg
                            &:hover
                                fill #424242 !important
                                stroke #424242 !important
                    svg
                        width 24px
                        height 24px
                        fill none
                        stroke #424242

                        &:hover
                            fill #017eff !important
                            stroke #017eff !important

                    &.opei-done
                        svg
                            fill #017eff !important
                            stroke #017eff !important
                    &.opei-doing
                        svg
                            fill tint(#017eff, 20%) !important
                            stroke tint(#017eff, 20%) !important

                    .ope-item-text
                        margin-left 6px
                        font-size 14px


        .tpl-preview-content
            display flex
            height calc(100% - 60px);
            position relative
            .hiddenSlide
                position absolute
                left -1000px

            .tpl-preview-left
                width 320px
                border-top 1px solid #e6e6e6
                background #f9f9f9
                border-right 1px solid #e6e6e6

                .tpl-mode-btn-box
                    display flex
                    justify-content space-between
                    padding 0 35px
                    margin-top 17px
                    margin-bottom 30px

                    .tpl-mode-btn
                        display inline-block
                        width 120px
                        height 36px
                        line-height 36px
                        background #000000
                        color #ffffff
                        border-radius 25px
                        text-align center
                        user-select none
                        cursor pointer

                        &.selected
                            background #00be84

                .tpl-mode-preview-list
                    padding-top 18px
                    height 100%
                    overflow auto

                    &::-webkit-scrollbar
                        width: 8px;
                        height: 6px;
                        pointer-events: none;
                        background: var(--backgroudColor);

                    &::-webkit-scrollbar-thumb:horizontal, &::-webkit-scrollbar-thumb:vertical
                        background: var(--scrollBackground);
                        border-radius: 4px;


                    .tmp-item
                        width 260px
                        margin 0 auto 10px
                        position relative
                        cursor pointer

                        .tmp-item-page-num
                            position absolute
                            right calc(100% + 5px)
                            text-align right
                            font-size 14px

                        .tmp-item-img-box
                            display flex
                            width 260px
                            padding 5px
                            background rgba(255, 255, 255, 0.15)
                            border-radius 2px
                            box-sizing border-box

                            svg
                                width 100%

                        .tmp-item-name
                            text-align center
                            margin-top 3px

                        &.selected
                            .tmp-item-page-num
                                color #017eff

                            .tmp-item-img-box
                                border 2px solid #017eff
                                padding 3px

                .tpl-mode-outline-list
                    .tmo-item
                        display flex
                        color #fff
                        height 50px
                        cursor pointer
                        align-items center

                        .tmo-item-page-num
                            flex 0 0 25px
                            text-align right
                            margin-right 10px

                        &.selected
                            background #424647

            .tpl-preview-right
                flex 1
                height 100%
                position relative
                overflow hidden

                .tpl-preview-right-loading
                    position absolute
                    z-index 777
                    width 100%
                    height 100%
                    background #fff
                    display flex
                    align-items center
                    justify-content center

                .preview-area
                    width 100%
                    height 100%
                    overflow hidden
                    position relative
                    background-color #e7e7e7
                    display flex
                    justify-content center
                    align-items center

                .work-outline
                    height 100%
                    overflow hidden
                    padding 20px 0 0 0
                    box-sizing border-box

                    .work-outline--wrap
                        height 100%
                        overflow auto

                    .work-outline--align
                        width 60%
                        margin 0 auto
                .tpl-preview-range
                    position absolute
                    bottom 30px
                    right 20px
                    display flex
                    justify-content center
                    align-items center
                    width 210px
                    height 34px
                    border-radius 20px
                    background #fff
                    box-shadow 0px 0px 6px rgba(0, 9, 16, 0.1)
                    svg
                        width 24px
                        height 24px
                        cursor pointer
                        fill #424242
                    .range-zoomText
                        position absolute
                        top -40px
                        left 31.2926px
                        padding 8px
                        background #000
                        border-radius 3px
                        display none
                        span
                            text-align center
                            font-size 12px
                            color #fff
                    &:hover .range-zoomText
                        display block
                .range-bar
                    display flex
                    width 120px
                    height 2px
                    background #fff
                input[type=range]
                    -webkit-appearance none
                    width 120px
                    height 2px
                    border-radius: 10px
                    background linear-gradient(#059CFA, #059CFA) no-repeat
                    background-size 10% 100%
                    border 1px solid #E9E9E9
                    box-sizing content-box
                    &:focus
                        outline none

                input[type=range]::-webkit-slider-thumb
                    -webkit-appearance none
                    position relative
                    width 10px
                    height 10px
                    border-radius 50%
                    background #fff
                    border 2px solid #017fff



        .work-preview--standpoint
            position absolute
            bottom 0
            left 0
            right 0
            text-align center
            color white
            background #222627
            z-index 10
            padding 10px
    .slider-present-tool
        z-index 1
        position fixed
        bottom 52px
        left 50%
        transform translateX(-50%)
        background-color #333333
        border-radius 4px
        padding 3px
        height 36px
        width 223px
        display flex
        justify-content space-around
        .item-icon
            width 30px
            height 30px
            border-radius 4px
            cursor pointer
            &:hover
                background-color #666666
    .report-reason
        .textarea-count
            position relative
            margin-bottom 10px

            .string-count
                position absolute
                color $text-color-light
                bottom 2px
                right 10px
                line-height normal

        .report-reason-hint
            color $text-color-light
            font-weight normal
            font-size 12px
            margin-top 16px
            height auto
            min-height 20px
            white-space normal

        .ed-modal-body
            padding-bottom 4px
            padding-top 6px

        .ed-modal-header
            border none

        .ed-modal-footer
            border none
    .upgrade-btn
        position relative
        display flex
        padding-right 16px
        align-items center
        height 100%
        white-space nowrap
        .vip-btn
            position relative
            height 34px
            padding 0 16px
            color #4A320E
            background: linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15)), linear-gradient(95.48deg, #FFDD63 9.58%, #FFC552 92.27%), linear-gradient(95.48deg, #FFD363 9.58%, #FFC552 92.27%);
            border-radius 210px
            line-height 34px
            text-align center
            font-size 12px
            font-weight bold
            cursor pointer
            width 100%
            white-space nowrap
            overflow hidden
            text-overflow ellipsis
            transition all .2s linear
            &:hover
                background: linear-gradient(95.48deg, #FFDD63 9.58%, #FFC552 92.27%), linear-gradient(95.48deg, #FFD363 9.58%, #FFC552 92.27%)
        .vip-tip
            position absolute
            top 46px
            left 50%
            z-index 1000
            cursor auto
            pointer-events none
            background #e4f2ff
            padding 14px 16px
            border-radius 4px
            color #333
            font-weight 700
            font-size 12px
            transform translateX(-50%)
            &::after
                content ''
                position: absolute
                top -16px
                left calc(50% - 8px)
                z-index 1000
                border 8px solid transparent
                border-bottom-color #e4f2ff
                cursor auto;
                pointer-events none
    .dark-theme__preview
        .tpl-preview-header
            background #222427
            color #fff
            .tpl-return svg
                fill #fff
            .work-ope-box
                .ope-item svg
                    stroke #fff
                .ope-ex-item svg
                    fill  #fff !important
            .work-spread
                fill #fff
        .tpl-preview-content
            .tpl-preview-right
                .preview-area
                    background #151515
                .tpl-preview-range
                    background #464647
                    .range-bar
                        background #e9e9e9
                    input[type=range]
                        border none
                    svg
                        fill #fff
            .tpl-preview-left
                background #222222
                border-color #151515
                .tpl-mode-preview-list
                    .tmp-item
                        .tmp-item-page-num,.tmp-item-name
                            color #fff
                        .tmp-item-img-box
                            background #333333
        .tpl-preview-mask
            background #151515
</style>
<template>
    <div
        v-show="showPreview"
        class="tpl-preview"
        :class="{ 'dark-theme__preview': isPCDarkMode == 2, 'pc-collection': pcCollection }"
        :style="pcSliderFitWidth"
    >
        <div v-if="showMask" class="tpl-preview-mask">
            <img style="width: 800px" :src="require('@/home/assets/img/logoanimation.gif')" alt="" />
        </div>
        <div class="tpl-preview-header">
            <div class="tpl-leftHeaderbox">
                <div class="tpl-return" @click="closePre">
                    <iconSymbol name="preview-back" />
                </div>
                <p class="work-title" :title="work.title">
                    {{ work.title }}
                </p>
            </div>
            <div class="work-zoom-box" v-if="false">
                <iconSymbol name="preview-zoom-down" @click.native="zoomDown" />
                <span class="work-zoom-info">{{ zoomText }}</span>
                <iconSymbol name="preview-zoom-up" @click.native="zoomUp" />
            </div>
            <div class="work-ope-box">
                <div v-if="showDownload" class="ope-item ope-download" @click="downloadWork">
                    <iconSymbol name="preview-report" />
                    <span class="ope-item-text">下载</span>
                </div>
                <!-- <div
                    v-show="work.allow_copy"
                    v-if="showOpe"
                    class="ope-item"
                    :class="{'opei-doing':doingClone}"
                >
                    <Tooltip
                        :content="cloneHintText"
                        :placement="'bottom'"
                        theme="light"
                    >
                    <div v-text=''></div>
                    </Tooltip>
                    
                </div>-->
                <div class="upgrade-btn" v-if="internal && !isPlugin">
                    <p class="vip-btn" v-show="!vip" @click="toVip">{{ $t("vip") }}</p>
                    <p
                        class="vip-tip"
                        v-show="
                            userInfo &&
                            userInfo.islogin &&
                            !vip &&
                            showVipFirstTip &&
                            cloneVipTips &&
                            work.price != 0 &&
                            boughtWorkIds.indexOf(work.id) == -1
                        "
                    >
                        {{ $t("vipFirstTip") }}
                    </p>
                </div>
                <div v-show="work.allow_copy || type == 'recent'" v-if="showOpe || type == 'recent' || isPlugin" class="ope-button" @click="clone()">
                    <Tooltip style="pointer-events: none" :content="cloneHintText" :placement="'bottom'" theme="light">
                        <img class="source-vip-icon" :src="require('@/home/assets/img/source-vip.png')" v-if="!internal && work.is_pay_package" />
                        {{ cloneText }}
                    </Tooltip>
                </div>
                <div v-show="work.allow_copy" v-if="showOpe" class="ope-item disabled-icon">
                    <Tooltip :content="$t('usedNums')" :placement="'bottom'" theme="light">
                        <iconSymbol name="preview-clone" />
                    </Tooltip>
                    <span class="ope-item-text">{{ work.used }}</span>
                </div>
                <div v-if="showOpe" class="ope-item ope-fill-item" :class="{ 'opei-done': hasCollected, 'opei-doing': doingCollect }">
                    <Tooltip :content="$t('collect')" :placement="'bottom'" theme="light">
                        <iconSymbol name="preview-collect" @click.native="collect(work.id)" />
                    </Tooltip>
                    <span class="ope-item-text">{{ work.collect }}</span>
                </div>
                <div v-if="showOpe && internal" class="ope-item ope-fill-item" :class="{ 'opei-done': hasLiked, 'opei-doing': doingLike }">
                    <Tooltip :content="$t('like')" :placement="'bottom'" theme="light">
                        <iconSymbol name="preview-like" @click.native="like(work.id)" />
                    </Tooltip>
                    <span class="ope-item-text">{{ work.like }}</span>
                </div>
                <div v-if="showOpe" class="ope-item ope-ex-item disabled-icon">
                    <Tooltip :content="$t('view')" :placement="'bottom'" theme="light">
                        <iconSymbol name="preview-pv" style="cursor: default" />
                    </Tooltip>
                    <span class="ope-item-text">{{ work.pv }}</span>
                </div>

                <div v-if="false && showOpe" class="ope-share-item">
                    <iconSymbol class="ope-share-item-black" name="preview-shareBlack" />
                    <iconSymbol class="ope-share-item-blue" name="preview-share" />
                    <span class="ope-item-text">{{ $t("share") }}</span>
                </div>
                <div v-if="showOpe" class="ope-item ope-fill-item" @click="report">
                    <iconSymbol name="preview-report" />
                    <span class="ope-item-text">{{ $t("report") }}</span>
                </div>
                <div v-if="false" class="ope-item" @click="closePre" style="margin-right: 20px; cursor: pointer">
                    <div id="preview-close-wrap">
                        <iconSymbol name="preview-close" style="pointer-events: none" />
                    </div>
                </div>
            </div>
            <iconSymbol v-show="pageDatas.length != 1" class="work-spread" :name="toggleIcon" @click.native="togglePre" />
            <!-- <div class="work-ope-close-box">
                <iconSymbol name="preview-close" @click.native="closePre" />
            </div> -->
        </div>
        <div class="tpl-preview-content">
            <div class="tpl-preview-right" ref="previewBox">
                <div
                    v-if="currentSVG"
                    ref="previewArea"
                    class="preview-area"
                    :class="{
                        'grab-cursor': zoomValue > 1,
                        'grabing-cursor': dragInfo && dragInfo.isDrag,
                    }"
                    @mousewheel="wheelZoom($event)"
                    @mousedown="startDrag($event)"
                    @mousemove="dragging($event)"
                    @mouseup="endDrag($event)"
                    @contextmenu.prevent
                >
                    <!-- <div
                        ref="previewCon"
                        class="preview-con"
                        @mousedown="startDrag($event)"
                        @mousemove="dragging($event)"
                        @mouseup="endDrag($event)"
                    >
                        <div
                            v-for="(page,index) in pageDatas"
                            v-show="showPageNum == index"
                            :key="index"
                            ref="previewSvg"
                            class="preview-svg"
                        />
                    </div>-->
                </div>
                <!-- <div class="work-preview--standpoint">
                    本作品由用户 {{ work.author }} 通过亿图图示发布，不代表亿图软件立场。如有违规内容，请点击举报。
                </div> -->
                <div class="tpl-preview-range" v-if="!fullScreenFlag">
                    <iconSymbol name="range-reduce" @click.native="zoomDown" />
                    <div class="range-bar">
                        <input id="zoomBar" min="0.2" max="10" step="0.05" type="range" :value="zoomValue" @input="dragZoom($event)" />
                    </div>
                    <div id="zoomText" class="range-zoomText">
                        <span>{{ zoomText }}</span>
                    </div>
                    <iconSymbol name="range-add" @click.native="zoomUp" />
                    <iconSymbol v-if="!isPC" name="preview-fullScreen" @click.native="fullScreen" />
                </div>

                <div v-if="showTools" ref="presentTools" class="slider-present-tool">
                    <iconSymbol @click.native.stop="upPage" class="item-icon" name="sliderToPrev" />
                    <iconSymbol @click.native.stop="downPage" class="item-icon" name="sliderToNext" />
                    <iconSymbol @click.native.stop.prevent="zoomUp" class="item-icon" name="sliderZoomUp" />
                    <iconSymbol @click.native.stop.prevent="zoomDown" class="item-icon" name="sliderZoomDown" />
                    <iconSymbol @click.native.stop="endFullScreen" class="item-icon" name="endSliderPresent" />
                </div>
            </div>
            <div class="tpl-preview-left" :class="{ hiddenSlide: !showLeft || pageDatas.length == 1 }">
                <div class="tpl-mode-preview-list">
                    <div
                        v-for="(data, index) in pageDatas"
                        :key="index"
                        class="tmp-item"
                        :class="{ selected: showPageNum == index }"
                        @click="switchPrePages(index)"
                        ref="previewLeft"
                    >
                        <div class="tmp-item-page-num">{{ index + 1 }}</div>
                        <div class="tmp-item-img-box"></div>
                        <div class="tmp-item-name">{{ data.name }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 举报输入框 -->
        <!-- <Modal
            v-model="showReportReason"
            :title="$t('report')"
            :loading="loading"
            :styles="{top:'auto'}"
            class-name="flex-center report-reason"
            :ok-text="$t('okText')"
            :cancel-text="$t('cancelText')"
            @on-ok="doReport"
            @on-cancel="cancelReport"
            width="560"
        >
            <template slot="header">
                <div class="ed-modal-header-inner">{{ $t('report') }}</div>
                <p class="report-reason-hint">{{ $t('reportInstruction') }}</p>
            </template>
            <Form v-if="showReportReason" ref="form" :model="form" :rules="ruleValidate">
                <FormItem :label="$t('reportTypeLabel')"  prop="reportRadio">
                    <RadioGroup v-model="form.reportRadio" vertical>
                        <Radio :label="0" :value="0">{{ $t('reportType1') }}</Radio>
                        <Radio :label="1" :value="1">{{ $t('reportType2') }}</Radio>
                        <Radio :label="2" :value="2">{{ $t('reportType3') }}</Radio>
                        <Radio :label="3" :value="3">{{ $t('reportType4') }}</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem :label="$t('reportResonLabel')" prop="reportReason" class="textarea-count">
                    <Input
                        v-model.trim="form.reportReason"
                        :placeholder="$t('reportReasonHint')"
                        :clearable="true"
                        type="textarea"
                    />
                    <span
                        :style="{color:form.reportReason.length >= 240 ? 'red' : ''}"
                        class="string-count"
                    >{{ form.reportReason.length }} / 240</span>
                </FormItem>
            </Form>
        </Modal> -->
        <reportAlert :showReportReason="showReportReason"></reportAlert>
        <!-- 立场提示 -->
        <tplClone />
    </div>
</template>

<i18n>
{
  "zh": {
    "bigger": "放大",
    "smaller": "缩小",
    "notes": "笔记",
    "image": "图形",
    "view": "浏览量",
    "like": "点赞",
    "collect": "收藏",
    "report": "举报",
    "share": "分享",
    "use": "使用此模板",
    "usedNums": "使用量",
    "cloneHint": {
      "memberFree": "会员免费",
      "free": "免费使用",
      "charge": "付费使用，需支付",
      "bought": "已购买，可直接使用"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "举报成功！",
      "reportOnce": "你已经举报过此作品",
      "cloning": "加载中..."
    },
    "reportInstruction": "为了保护您和被举报人的权利，请您慎重填写举报原因，我们会认真核实。",
    "reportReasonHint": "举报原因（5个字符以上）*",
    "validateWarn": {
      "reasonRequire": "举报原因不能为空！",
      "reasonLength": "举报原因不能少于5个字符且不能多于240个字符！"
    },
    "reportResonLabel": "举报理由",
    "reportTypeLabel": "举报类型",
    "reportType1": "违法违规：色情、暴力、血腥、敏感信息等",
    "reportType2": "盗用作品：侵犯原创作者的版权",
    "reportType3": "垃圾广告：广告推销",
    "reportType4": "其他理由",
    "noSpaceVip": "云空间已满",
    "previewMode": "预览模式",
    "noteMode": "笔记模式",
    "okText": "确定",
    "cancelText": "取消",
    "vip": "开通VIP",
    "vipFirstTip": "开通vip，立享首次使用模板免单福利！",
    "buynow": "直接购买",
    "clone": "使用模板",
    "cloneTip": "您已成为会员，可享受首次使用任意付费导图免单福利。",
    "newFile": "未命名文件",
    "fileSelectorTitle": "选择文件",
    "tip": "Edraw 提醒",
    "useSymbolTip": "当前版本不支持使用符号模板，升级更新至v11.5.0以上版本即可立即使用",
    "toUpgrade": "去升级"
  },
  "en": {
    "bigger": "Zoom in",
    "smaller": "Zoom out",
    "notes": "Notes",
    "image": "Image",
    "view": "Pageviews",
    "like": "Likes",
    "collect": "Favorites",
    "report": "Report",
    "share": "Share",
    "use": "Use immediately",
    "usedNums": "Usage amount",
    "cloneHint": {
      "memberFree": "Free for members",
      "free": "Free to Use",
      "charge": "Pay to Use",
      "bought": "Paid"
    },
    "currency": {
      "unit": "Dollar",
      "symbol": "$"
    },
    "message": {
      "reportSuccess": "Report successfully!",
      "reportOnce": "You have already reported this ",
      "cloning": "loading..."
    },
    "reportInstruction": "In order to protect the rights of you and the informant, please carefully fill in the reasons for reporting, we will carefully verify.",
    "reportReasonHint": "Report reason（Description should be at least 5 characters in length）*",
    "validateWarn": {
      "reasonRequire": "The report reason cannot be blank!",
      "reasonLength": "The reason for reporting cannot be less than 5 characters and no more than 240 characters!"
    },
    "reportResonLabel": "Reason",
    "reportTypeLabel": "Report type",
    "reportType1": "Violation of laws and regulations: pornography, violence, blood, sensitive information, etc.",
    "reportType2": "Misappropriation of works: infringement of the copyright of the original author",
    "reportType3": "Spam ads: advertising promotion",
    "reportType4": "Other reasons",
    "noSpaceVip": "The cloud storage is full.",
    "previewMode": "Preview mode",
    "noteMode": "Note mode",
    "okText": "OK",
    "cancelText": "Cancel",
    "vip": "Upgrade",
    "vipFirstTip": "Upgrade now and get a paid template for free.",
    "buynow": "Buy Now",
    "clone": "Use Template",
    "newFile": "Unnamed File",
    "cloneTip": "You are now a VIP member. Enjoy your first paid template for free",
    "fileSelectorTitle": "Select File",
    "tip": "Edraw tips",
    "useSymbolTip": "The current version does not support the Symbols Templates function. Please update to V11.5 or later versions to use it.",
    "toUpgrade": "Update Now"
  },
  "de": {
    "bigger": "Zoom in",
    "smaller": "Zoom out",
    "notes": "Notiz",
    "image": "Bild",
    "view": "Ansichten",
    "like": "Likes",
    "collect": "Favoriten",
    "report": "Bericht",
    "share": "Teilen",
    "use": "Diese Vorlage verwenden",
    "usedNums": "Nutzungsmenge",
    "cloneHint": {
      "memberFree": "Kostenlos für Mitglieder",
      "free": "Kostenlos zu benutzen",
      "charge": "Verwendung bezahlen",
      "bought": "Bezahlt"
    },
    "currency": {
      "unit": "RMB",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "Erfolgreich gemeldet!",
      "reportOnce": "Sie haben diese Arbeit bereits gemeldet",
      "cloning": "Wird geladen..."
    },
    "reportInstruction": "Um die Rechte von Ihnen und dem Informanten zu schützen, geben Sie bitte die Gründe für die Meldung sorgfältig an. Wir werden dies sorgfältig überprüfen.",
    "reportReasonHint": "Grund melden （Beschreibung sollte mindestens 5 Zeichen lang sein） *",
    "validateWarn": {
      "reasonRequire": "Der Berichtsgrund darf nicht leer sein!",
      "reasonLength": "Der Grund für die Meldung darf nicht weniger als 5 Zeichen und nicht mehr als 240 Zeichen betragen!"
    },
    "reportResonLabel": "Meldungsgrund",
    "reportTypeLabel": "Meldungstyp",
    "reportType1": "Verstöße gegen Gesetze und Vorschriften: Pornografie, Gewalt, Blut, sensible Informationen usw. ",
    "reportType2": "Veruntreuung von Werken: Verletzung des Urheberrechts des ursprünglichen Autors",
    "reportType3": "Spam-Anzeigen: Werbung",
    "reportType4": "Andere Gründe",
    "noSpaceVip": "Keinen Cloud-Speicherplatz",
    "previewMode": "Vorbild Modus",
    "noteMode": "Notiz-Modus",
    "okText": "Sichern",
    "cancelText": "Abbrechen",
    "newFile": "Unbenannte Datei",
    "fileSelectorTitle": "Wählen Sie ein Dokument aus",
    "tip": "Edraw Tipps",
    "useSymbolTip": "Die aktuelle Version unterstützt die Funktion Symbolvorlagen nicht. Bitte aktualisieren Sie auf V11.5 oder neuere Versionen, um es zu verwenden.",
    "toUpgrade": "Jetzt Aktualisieren"
  },
  "fr": {
    "bigger": "Zoom avant",
    "smaller": "Zoom arrière",
    "notes": "Notes",
    "image": "Graphique",
    "view": "Pages vues",
    "like": "Aimes",
    "collect": "Favoris",
    "report": "Rapport",
    "share": "Partager",
    "use": "Utilisez ce modèle",
    "usedNums": "Montant d'utilisation",
    "cloneHint": {
      "memberFree": "Gratuit pour les membres",
      "free": "Utilisation gratuite",
      "charge": "Payer pour utiliser",
      "bought": "Paid"
    },
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "message": {
      "reportSuccess": "Rapporté avec succès!",
      "reportOnce": "Vous avez déjà signalé ce travail.",
      "cloning": "chargement..."
    },
    "reportInstruction": "Afin de protéger vos droits et ceux de l'informateur, veuillez indiquer soigneusement les raisons du signalement, nous vérifierons soigneusement.",
    "reportReasonHint": "Raison du rapport (la description doit comporter au moins 5 caractères) *",
    "validateWarn": {
      "reasonRequire": "La raison du rapport ne peut pas être vide!",
      "reasonLength": "La raison du signalement ne peut pas être inférieure à 5 caractères et pas plus de 240 caractères!"
    },
    "reportResonLabel": "Raison du signalement",
    "reportTypeLabel": "Type de rapport",
    "reportType1": "Violation des lois et règlements: pornographie, violence, sang, informations sensibles, etc.",
    "reportType2": "Détournement d'œuvres: violation du droit d'auteur de l'auteur original",
    "reportType3": "Annonces de spam: promotion publicitaire",
    "reportType4": "Autres raisons",
    "noSpaceVip": "L'espace nuage est plein",
    "previewMode": "Mode aperçu",
    "noteMode": "Mode note",
    "okText": "Créer",
    "newFile": "Fichier sans nom",
    "cancelText": "Annuler",
    "fileSelectorTitle": "Sélectionnez un document",
    "tip": "Rappel Edraw",
    "useSymbolTip": "La version actuelle ne prend pas en charge la fonction Modèles de symboles. Veuillez mettre à jour vers la V11.5 ou les versions ultérieures pour l'utiliser.",
    "toUpgrade": "Mettez à jour"
  },
  "es": {
    "bigger": "Acercar",
    "smaller": "Alejar",
    "notes": "Notas",
    "image": "Gráfico",
    "view": "Páginas vistas",
    "like": "Likes",
    "collect": "Favoritos",
    "report": "Reportar",
    "share": "Compartir",
    "use": "Usa esta plantilla",
    "usedNums": "Cantidad de uso",
    "cloneHint": {
      "memberFree": "Gratis para miembros",
      "free": "Gratis",
      "charge": "Pagos",
      "bought": "Pagados"
    },
    "currency": {
      "unit": "Yuan",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "¡Reportado exitosamente!",
      "reportOnce": "Ya has reportado de este trabajo",
      "cloning": "cargando..."
    },
    "reportInstruction": "Con el fin de proteger los derechos de usted y del informante, por favor complete cuidadosamente las razones para informar, lo verificaremos cuidadosamente.",
    "reportReasonHint": "Motivo del reporte （La descripción debe tener al menos 5 caracteres de longitud） *",
    "validateWarn": {
      "reasonRequire": "¡El motivo del reporte no puede estar en blanco!",
      "reasonLength": "¡El motivo de la denuncia no puede tener menos de 5 caracteres ni más de 240 caracteres!"
    },
    "reportResonLabel": "Razón del reporte ",
    "reportTypeLabel": "Tipo de reporte ",
    "reportType1": "Violaciones y Sanciones: pornografía, violencia, sangre, información sensible, etc.",
    "reportType2": "Apropiación indebida de obras: infracción de los derechos de autor del autor original",
    "reportType3": "Anuncios de spam: promoción publicitaria",
    "reportType4": "Otras razones",
    "noSpaceVip": "El espacio en la nube está lleno",
    "previewMode": "Modo de vista previa",
    "noteMode": "Modo de nota",
    "okText": "Confirmar",
    "newFile": "Archivo sin nombre",
    "cancelText": "Cancelar",
    "fileSelectorTitle": "Seleccionar un documento",
    "tip": "Consejos de Edraw",
    "useSymbolTip": "La versión actual no admite la función Plantillas de símbolos. Actualice a V11.5 o posterior para usarlo.",
    "toUpgrade": "Actualizar"
  },
  "jp": {
    "bigger": "ズームイン",
    "smaller": "ズームアウト",
    "notes": "注釈",
    "image": "图形",
    "view": "ページビュー",
    "like": "いいね",
    "collect": "お気に入り",
    "report": "報告",
    "share": "共有",
    "use": "このテンプレートを使用する",
    "usedNums": "使用回数",
    "cloneHint": {
      "memberFree": "会員無料",
      "free": "無料機能",
      "charge": "有料機能",
      "bought": "購入済み"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "正常に報告しました。",
      "reportOnce": "この作品はすでに報告されました。",
      "cloning": "読み込み中..."
    },
    "reportInstruction": "報告者と報告される方の権利を保護するため、報告理由を慎重に記入してください。",
    "reportReasonHint": "報告理由（5文字以上）*",
    "validateWarn": {
      "reasonRequire": "報告理由を記入してください。",
      "reasonLength": "報告する理由は、5文字以上240文字以下にする必要があります。"
    },
    "reportResonLabel": "報告理由",
    "reportTypeLabel": "報告タイプ",
    "reportType1": "法律違反：ポルノ、暴力、血、機密情報など",
    "reportType2": "著作物の無断使用：著作権侵害",
    "reportType3": "スパム広告：広告宣伝",
    "reportType4": "その他",
    "noSpaceVip": "クラウドストレージがいっぱいです",
    "previewMode": "预览模式",
    "noteMode": "笔记模式",
    "okText": "確認",
    "newFile": "名前のないファイル",
    "cancelText": "キャンセル",
    "fileSelectorTitle": "ファイル選択",
    "tip": "Edrawからのご注意",
    "useSymbolTip": "現在のバージョンでは、「記号のテンプレート機能」に対応していません。V11.5以降のバージョンにアップデートしてください。",
    "toUpgrade": "今すぐアップデート"
  },
  "pt": {
    "bigger": "Prolongar",
    "smaller": "Encolher",
    "notes": "Notas",
    "image": "Gráficos",
    "view": "Visualizações de página",
    "like": "Gosto",
    "collect": "Coletar",
    "report": "Reportar",
    "share": "Compartihar",
    "use": "Usar este modelo",
    "usedNums": "Quantidade de uso",
    "cloneHint": {
      "memberFree": "Grátis para membros",
      "free": "Livre para usar",
      "charge": "Uso pago, precisar de pagar",
      "bought": "Foi comprado e pode ser usado diretamente"
    },
    "currency": {
      "unit": "yuan",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "Reportar com sucesso!",
      "reportOnce": "Você já reportou este trabalho",
      "cloning": "Carregando..."
    },
    "reportInstruction": "Para proteger os seus direitos e os do informante, preencha cuidadosamente os motivos da denúncia, que iremos verificar cuidadosamente.",
    "reportReasonHint": "Motivo da reporta (a descrição deve ter pelo menos 5 caracteres)*",
    "validateWarn": {
      "reasonRequire": "O motivo da reporta não pode ficar em branco!",
      "reasonLength": "O motivo da denúncia não pode ter menos de 5 caracteres e não mais de 240 caracteres!"
    },
    "reportResonLabel": "Razão da reporta",
    "reportTypeLabel": "Tipo da reporta",
    "reportType1": "Violação de leis e regulamentos: pornografia, violência, sangue, informações confidenciais, etc.",
    "reportType2": "Apropriação indébita de obras: violação dos direitos autorais do autor original",
    "reportType3": "Anúncios de spam: promoção de publicidade",
    "reportType4": "Outras razões",
    "noSpaceVip": "O espaço da nuvem está cheio",
    "previewMode": "Modo de pré-visualização",
    "noteMode": "Modo de nota",
    "okText": "OK",
    "newFile": "Ficheiro Sem Nome",
    "cancelText": "Cancelar",
    "fileSelectorTitle": "Selecione um documento",
    "tip": "Dicas Edraw",
    "useSymbolTip": "A versão atual não suporta a função de Modelos de Símbolos. Por favor atualize para V11.5 ou versões posteriores para usá-lo.",
    "toUpgrade": "Atualize Agora"
  },
  "it": {
    "bigger": "Ingrandire",
    "smaller": "Riduci lo zoom",
    "notes": "Appunti",
    "image": "Grafico",
    "view": "Visualizzazioni di pagina",
    "like": "Piace",
    "collect": "Preferiti",
    "report": "Rapporto",
    "share": "Condivide",
    "use": "Usa questo modello",
    "usedNums": "Quantità di utilizzo",
    "cloneHint": {
      "memberFree": "Gratuito per i membri",
      "free": "L'uso gratuito",
      "charge": "Paga per l'uso",
      "bought": "Pagato"
    },
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "message": {
      "reportSuccess": "Segnalato con successo!",
      "reportOnce": "Hai già segnalato questo lavoro.",
      "cloning": "Caricamento in corso..."
    },
    "reportInstruction": "Al fine di tutelare i tuoi diritti e quelli dell'informatore, ti preghiamo di indicare attentamente i motivi della segnalazione, che controlleremo attentamente.",
    "reportReasonHint": "Motivo della segnalazione (la descrizione deve contenere almeno 5 caratteri)*",
    "validateWarn": {
      "reasonRequire": "Il motivo del rapporto non può essere vuoto！",
      "reasonLength": "Il motivo della segnalazione non può essere inferiore a 5 caratteri e non superiore a 240 caratteri!"
    },
    "reportResonLabel": "Motivo della relazione",
    "reportTypeLabel": "Tipo di rapporto",
    "reportType1": "Violazione di leggi e regolamenti: pornografia, violenza, sangue, informazioni sensibili, ecc.",
    "reportType2": "Appropriazione indebita di opere: violazione del copyright dell'autore originale",
    "reportType3": "Annunci spam: promozione pubblicitaria",
    "reportType4": "Altri motivi",
    "noSpaceVip": "Lo spazio cloud è pieno",
    "previewMode": "Modalità anteprima",
    "noteMode": "Modalità nota",
    "okText": "OK",
    "newFile": "File Senza Nome",
    "cancelText": "Annulla",
    "fileSelectorTitle": "Seleziona un documento",
    "tip": "Suggerimenti di Edraw",
    "useSymbolTip": "La versione corrente non supporta la funzione Modelli di Simboli. Si prega di aggiornare a V11.5 o versioni successive per usarlo.",
    "toUpgrade": "Aggiorna Ora"
  },
  "tw": {
    "bigger": "放大",
    "smaller": "縮小",
    "notes": "筆記",
    "image": "圖形",
    "view": "瀏覽量",
    "like": "點讚",
    "collect": "收藏",
    "report": "舉報",
    "share": "分享",
    "use": "使用此模板",
    "usedNums": "使用量",
    "cloneHint": {
      "memberFree": "會員免費",
      "free": "免費使用",
      "charge": "付費使用，需支付",
      "bought": "已購買，可直接使用"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "舉報成功！",
      "reportOnce": "你已經舉報過此產品",
      "cloning": "加載中..."
    },
    "reportInstruction": "為了保護您和被舉報人的權利，請您謹慎填寫舉報原因，我們會認真核實。",
    "reportReasonHint": "舉報原因（5個字符以上）*",
    "validateWarn": {
      "reasonRequire": "舉報原因不能為空！",
      "reasonLength": "舉報原因不能少於5個字符且不能多於240個字符！"
    },
    "reportResonLabel": "舉報理由",
    "reportTypeLabel": "舉報類型",
    "reportType1": "違法違規：色情、暴力、血腥、敏感信息等",
    "reportType2": "盜用作品：侵犯原創作者的版權",
    "reportType3": "垃圾廣告：廣告推銷",
    "reportType4": "其他理由",
    "noSpaceVip": "雲端硬碟已滿",
    "previewMode": "預覽模式",
    "noteMode": "筆記模式",
    "okText": "確定",
    "newFile": "未命名檔案",
    "cancelText": "取消",
    "fileSelectorTitle": "選擇文件",
    "tip": "Edraw 提醒",
    "useSymbolTip": "當前版本不支持使用符號模板，升級更新至V11.5.0以上版本立即使用",
    "toUpgrade": "去升級"
  },
  "kr": {
    "bigger": "확대",
    "smaller": "축소",
    "notes": "노트",
    "image": "이미지",
    "view": "조회수",
    "like": "좋아요",
    "collect": "즐겨찾기",
    "report": "신고",
    "share": "공유",
    "use": "템플릿 적용하기",
    "usedNums": "적용 횟수",
    "cloneHint": {
      "memberFree": "회원 무료",
      "free": "무료 사용",
      "charge": "유료 사용",
      "bought": "구매 완료, 바로 사용 가능"
    },
    "currency": {
      "unit": "원",
      "symbol": "₩"
    },
    "message": {
      "reportSuccess": "신고 성공!",
      "reportOnce": "이미 신고하셨습니다!",
      "cloning": "로딩중..."
    },
    "reportInstruction": "귀하와 피신고자의 권리를 보호하기 위해 신고 사유를 신중히 기입해 주시면 꼼꼼하게 확인하겠습니다.",
    "reportReasonHint": "신고 이유（5자 이상）*",
    "validateWarn": {
      "reasonRequire": "신고 이유를 비워둘 수 없습니다.",
      "reasonLength": "신고 이유는 5 자 이상 240 자 이하여야 합니다!"
    },
    "reportResonLabel": "신고 이유",
    "reportTypeLabel": "신고 유형",
    "reportType1": "법률 및 규정 위반 : 포르노, 폭력, 혈성, 민감 정보 등",
    "reportType2": "저작물의 도용 : 원저작자의 저작권 침해",
    "reportType3": "스팸 : 광고 ",
    "reportType4": "기타 이유",
    "noSpaceVip": "클라우드 공간이 부족합니다.",
    "previewMode": "미리 보기 모드",
    "noteMode": "노트모드",
    "okText": "확인",
    "cancelText": "취소",
    "vip": "VIP 회원을 개설합니다",
    "vipFirstTip": "VIP 개통, 첫 번째 템플릿 사용 무료 혜택을 받아보세요!",
    "buynow": "지금 구매",
    "clone": "템플릿 사용",
    "cloneTip": "당신은 이제 VIP 회원이 되었습니다. 첫 번째 유료 템플릿을 무료로 즐기십시오.",
    "newFile": "이름 없는 파일",
    "fileSelectorTitle": "문서 선택",
    "tip": "Edraw 팁",
    "useSymbolTip": "현재 버전은 기호 템플릿 기능을 지원하지 않습니다. V11.5.0버전 이상으로 업그레이드하면 사용할 수 있습니다.",
    "toUpgrade": "업그레이드하기"
  },
  "id": {
    "bigger": "Perbesar",
    "smaller": "Perkecil",
    "notes": "Catatan",
    "image": "Gambar",
    "view": "Tampilan Halaman",
    "like": "Suka",
    "collect": "Favorit",
    "report": "Laporkan",
    "share": "Bagikan",
    "use": "Gunakan segera",
    "usedNums": "Jumlah penggunaan",
    "cloneHint": {
      "memberFree": "Gratis untuk anggota",
      "free": "Penggunaan Gratis",
      "charge": "Penggunaan Berbayar",
      "bought": "Berbayar"
    },
    "currency": {
      "unit": "Dolar",
      "symbol": "$"
    },
    "message": {
      "reportSuccess": "Laporan berhasil!",
      "reportOnce": "Anda telah melaporkan hal ini ",
      "cloning": "memuat ...."
    },
    "reportInstruction": "Untuk melindungi hak Anda dan informan, isi alasan pelaporan dengan teliti, kami akan memverifikasi dengan cermat.",
    "reportReasonHint": "Alasan laporan（Deskripsi harus berisi setidaknya 5 karakter）*",
    "validateWarn": {
      "reasonRequire": "Alasan laporan tidak boleh kosong!",
      "reasonLength": "Alasan pelaporan tidak boleh kurang dari 5 karakter dan tidak lebih dari 240 karakter!"
    },
    "reportResonLabel": "Alasan",
    "reportTypeLabel": "Jenis laporan",
    "reportType1": "Pelanggaran terhadap undang-undang dan peraturan: pornografi, kekerasan, darah, informasi sensitif, dsb.",
    "reportType2": "Penyalahgunaan karya: pelanggaran hak cipta penulis asli",
    "reportType3": "Iklan spam: Promosi iklan",
    "reportType4": "Alasan lain",
    "noSpaceVip": "Penyimpanan cloud penuh.",
    "previewMode": "Mode pratinjau",
    "noteMode": "Mode catatan",
    "okText": "OKE",
    "cancelText": "Batalkan",
    "vip": "Tingkatkan",
    "vipFirstTip": "Tingkatkan sekarang dan dapatkan templat berbayar gratis.",
    "buynow": "Beli Sekarang",
    "clone": "Gunakan Templat",
    "newFile": "File Tanpa Nama",
    "cloneTip": "Anda sekarang menjadi anggota VIP. Nikmati templat berbayar pertama Anda secara gratis",
    "fileSelectorTitle": "Pilih File",
    "tip": "Tip Edraw",
    "useSymbolTip": "Versi saat ini tidak mendukung fungsi Templat Simbol. Perbarui ke V11.5 atau versi yang lebih baru untuk menggunakannya.",
    "toUpgrade": "Perbarui Sekarang"
  }
}
</i18n>

<script>
    import { EDRAWMAX_PRODUCT_VIPLIMIT } from "@/env/";
    import axios from "axios";
    import reportAlert from "./alert/reportAlert";
    import tplClone from "./tplClone";
    import get from "lodash/get";
    import appConfig from "@/public/globalConfig";
    export default {
        name: "TplPreview",
        components: {
            reportAlert,
            tplClone,
        },
        data() {
            return {
                //正在执行操作的标志
                doingLike: false,
                doingCollect: false,
                doingClone: false,

                showLeft: true,
                showMask: false,

                pageDatas: [],
                showPageNum: 0,
                zoomValue: 1,
                xOffset: 0,
                yOffset: 0,
                dragInfo: {
                    startX: "",
                    startY: "",
                    startScrollLeft: "",
                    startScrollTop: "",
                    isDrag: false,
                },

                //是否显示举报理由输入框
                showReportReason: false,
                form: {
                    reportReason: "",
                    reportRadio: 3,
                },

                loading: true,

                fullScreenFlag: false,
                showTools: false,
                cloneVipTips: true,

                // vipfirst
                vipFirstFlag: false,
                showVipFirstTip: false, // 是否享受过首单免费
                pcBuyFlag: false, // 是否唤起pc登录窗口，vip状态改变时刷新首单免费状态
                getingSvg: false,
            };
        },
        computed: {
            showPreview: {
                get: function () {
                    return this.$store.state.showPreviewTemp;
                },
                set: function (newValue) {
                    this.$store.commit("setShowPreview", newValue);

                    if (newValue) {
                        this.$nextTick(() => {
                            window.parent && window.parent.postMessage("isReady", "*");
                        });
                    }
                },
            },
            userInfo() {
                return this.$store.state.userInfo;
            },
            currentSVG() {
                return this.pageDatas[this.showPageNum];
            },
            type() {
                return this.$store.state.tplCenter.previewContext;
            },
            work() {
                return this.$store.state.tplCenter.activeWork;
            },
            zoomText() {
                return (this.zoomValue * 100).toFixed() + "%";
            },
            isParttime() {
                return this.$store.state.tplCenter.parttime;
            },
            toggleIcon() {
                return this.showLeft ? "preview-spread" : "preview-folded";
            },
            //是否显示喜欢、收藏、点赞、举报等
            showOpe() {
                if (this.isPlugin) return false;
                let type = this.type;
                return type == "center" || type == "collection" || type == "userWorks";
            },
            //是否显示下载按钮
            showDownload() {
                let type = this.type;
                return (type == "review" || type == "report") && !this.isParttime && !this.isPlugin;
            },
            //是否点赞过
            hasLiked() {
                let ids = this.$store.state.tplCenter.likeIds;
                return ids.includes(this.work.id);
            },
            //是否收藏过
            hasCollected() {
                let ids = this.$store.state.tplCenter.collectIds;
                return ids.includes(this.work.id);
            },
            boughtWorks() {
                return this.$store.state.tplCenter.boughtWorks;
            },
            //是否购买过
            hasBought() {
                return this.boughtWorkIds.includes(this.work.id);
            },
            boughtWorkIds() {
                let ids = [];
                this.boughtWorks &&
                    this.boughtWorks.forEach((item) => {
                        ids.push(item.work_id);
                    });
                return ids;
            },
            cloneHintText() {
                let text = "",
                    work = this.work;
                if (work.member_free) {
                    text = this.$t("cloneHint.memberFree");
                } else if (work.price == 0) {
                    text = this.$t("cloneHint.free");
                } else if (this.boughtWorkIds.indexOf(work.id) == -1) {
                    text = this.$t("cloneHint.charge") + this.$t("currency.iconSymbol") + work.price;
                } else {
                    text = this.$t("cloneHint.bought");
                }
                return text;
            },
            cloneText() {
                let text = "",
                    work = this.work;

                if (work.member_free || work.price == 0) {
                    text = "";
                } else if (this.boughtWorkIds.indexOf(work.id) == -1) {
                    if (this.internal) {
                        text = `（￥${work.price}）`;
                    } else {
                        text = `（${this.$t("currency.symbol")}${work.price}）`;
                    }
                } else {
                    text = "";
                }
                return this.$t("use") + text;
            },
            // ruleValidate() {
            //     return {
            //         reportReason: [
            //             {
            //                 required: true,
            //                 message: this.$t("validateWarn.reasonRequire"),
            //                 trigger: "blur"
            //             },
            //             {
            //                 type: "string",
            //                 min: 5,
            //                 max: 240,
            //                 message: this.$t("validateWarn.reasonLength"),
            //                 trigger: "blur"
            //             }
            //         ],
            //         reportRadio: [
            //             {
            //                 required: true,
            //             },
            //         ]
            //     };
            // },
            trackClass() {
                return this.$store.state.trackClass;
            },
            isSymbol() {
                // 是否是符号模板
                return this.work.type == "edt";
            },
            pcLogin() {
                return get(this.userInfo, "user_id", "") || "";
            },
            pcCollection() {
                // v12 pc收藏tab兼容
                return this.isPC && this.type == "collection";
            },
            pcSliderFitWidth() {
                if (this.isPC && this.pcCollection) {
                    if (this.isNewPcView) {
                        return {
                            left: "0",
                        };
                    }
                    return {
                        left: `${this.$store.state.pcSliderFitWidth}px`,
                    };
                }
                return "";
            },
            isNewPcView() {
                return this.isPC && this.$isBiggerVersion("13.0.0");
            },
        },
        watch: {
            type(val) {
                if (val) {
                    this.showPreview = true;
                    this.showPre();
                }
            },
            showPageNum(val) {
                if (val != null && this.showPreview) {
                    this.showRightSVG(val);
                    this.tempZoomReset();
                }
            },
            currentSVG(val) {
                if (val && val.html) {
                    this.$nextTick(() => {
                        let container = this.$refs.previewArea;
                        container.children[0].style.maxWidth = this.currentSVG.width + "px";
                        container.children[0].style.maxHeight = this.currentSVG.height + "px";
                        this.resizeEvent();
                    });
                }
            },
            showPreview(val) {
                if (!val) {
                    this.$store.commit("toTplCenter", {
                        name: "previewContext",
                        data: false,
                    });
                    window.removeEventListener("resize", this.resizeEvent);
                    this.showMask = false;
                    this.resetPreviewOption();
                } else {
                    this.showMask = true;

                    this.sensors.track("templatePreviewPage", {
                        Catalogues: "Templates",
                        platform: this.isPC ? "desktop" : "online",
                    });
                    this.getSvg();
                }
            },
            vip(v) {
                if (this.pcBuyFlag && v) {
                    this.pcBuyFlag = false;
                    this.checkFirstVip();
                }
            },
            pcLogin(val, oldval) {
                if (val && this.isPC) {
                    let cloneVipTips = JSON.parse(localStorage.getItem("cloneVipTips"));
                    this.cloneVipTips = !(cloneVipTips && cloneVipTips.includes(this.userInfo.user_id));
                    console.log("cloneVipTips---", this.cloneVipTips);
                    this.checkFirstVip();
                }
            },
            work(nv, ov) {
                if (nv != ov && this.showPreview) {
                    this.resetPreviewOption();
                    this.getSvg();
                }
            },
        },
        created() {
            //其他地方手动触发clone事件
            // this.$bus.$on("doClone", () => {
            //     this.clone();
            // });
            this.$bus.$on("closePreview", () => {
                this.closePre();
            });
            this.$bus.$on("loginSucc-preview", () => {
                if (this.showPreview) {
                    this.$edApi
                        .viewOrReportWork(
                            Object.assign(
                                {
                                    id: this.params.id,
                                    workId: this.work.id,
                                    preview: 1,
                                },
                                this.params
                            )
                        )
                        .then(() => {
                            // this.$bus.$emit("updateWorkIds", { id: work.id, type: "pv" });
                            this.work.pv += 1;
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
                let cloneVipTips = JSON.parse(localStorage.getItem("cloneVipTips"));
                this.cloneVipTips = !(cloneVipTips && cloneVipTips.includes(this.userInfo.user_id));
                console.log("cloneVipTips---", this.cloneVipTips);
                this.checkFirstVip();
            });
            // this.$bus.$on('checkVipFirst', () => {
            //     this.checkFirstVip()
            // })
            window.addEventListener("resize", this.resizeEvent);
            window.addEventListener("keydown", this.togglePreEvent);

            // window.addEventListener('DOMMouseScroll', zoomFunc, { passive: false }); //firefox;
            // window.addEventListener('wheel', zoomFunc, { passive: false });//IE/Opera/Chrome/Safari
        },
        methods: {
            resetPreviewOption() {
                this.pageDatas = [];
                this.tempZoomReset();
                this.showPageNum = 0;
            },
            switchPrePages(index) {
                this.showPageNum = index;
                this.zoomValue = 1;
            },
            togglePreEvent(e) {
                if (!this.showPreview) return;
                let code = e.keyCode;
                if ((code === 37 || code === 38 || code === 33 || code === 80) && this.showPageNum > 0) {
                    this.showPageNum -= 1;
                } else if (
                    (code === 39 || code === 40 || code === 32 || code === 78 || code === 34) &&
                    this.showPageNum + 1 < this.pageDatas.length
                ) {
                    this.showPageNum += 1;
                }
            },
            togglePre() {
                this.showLeft = !this.showLeft;
            },
            resizeEvent() {
                if (!this.showPreview) return;
                let container = this.$refs.previewArea;
                if (!container) return;
                let conWidth = container.clientWidth;
                let conHeight = container.clientHeight;
                let pageRatio = this.currentSVG.height / this.currentSVG.width;
                let width, height;
                let svg = container.children[0];
                if (conHeight / conWidth > pageRatio) {
                    width = conWidth;
                    height = conWidth * pageRatio;
                } else {
                    height = conHeight;
                    width = conHeight / pageRatio;
                }

                svg.style.width = width + "px";
                svg.style.height = height + "px";
            },
            wheelZoom(e) {
                // 禁止Ctrl 滚轮缩放事件，WheelDelta +/-120 表示上下滚动，火狐是-/+ 3。
                let ts = this;
                let target = e.target;

                let ctrlkey = e.ctrlKey || e.metaKey;
                if (ctrlkey) {
                    if (ts.$refs.previewArea.contains(target)) {
                        if (e["wheelDelta"]) {
                            //IE/Opera/Chrome
                            if (e["wheelDelta"] > 0) {
                                ts.tempZoomUp(e);
                            } else {
                                ts.tempZoomDown(e);
                            }
                            e.preventDefault();
                        } else if (e.detail) {
                            //Firefox
                            if (e.detail < 0) {
                                ts.tempZoomUp(e);
                            } else {
                                ts.tempZoomDown(e);
                            }
                            e.preventDefault();
                        }
                    }
                } else {
                    let scollHeight = 0;
                    let maxPage = this.pageDatas.length - 1;
                    let count = this.showPageNum;
                    if (e["wheelDelta"]) {
                        //IE/Opera/Chrome
                        if (e["wheelDelta"] > 0) {
                            scollHeight = 100;
                        } else {
                            scollHeight = -100;
                        }
                        e.preventDefault();
                    } else if (e.detail) {
                        //Firefox
                        if (e.detail < 0) {
                            scollHeight = 100;
                        } else {
                            scollHeight = -100;
                        }
                        e.preventDefault();
                    }
                    this.yOffset += scollHeight;
                    this.recXEvent();
                }
            },
            closePre() {
                this.showPreview = false;
                if (this.isParttime) {
                    this.$store.commit("toTplCenter", {
                        name: "showReviewModify",
                        data: false,
                    });
                }
                if (this.isPC) {
                    // pc不能去除url参数
                    return;
                }
                let tempUrl = window.location.origin + location.pathname + location.search;
                history.replaceState(history.state, "", tempUrl);
            },
            tempZoomUp(e) {
                if (Math.abs(this.zoomValue - 10) < Number.EPSILON) return;
                let newZoom = parseFloat((this.zoomValue + 0.2).toFixed(1));
                this.zoomFunc(e, newZoom);
            },
            tempZoomDown(e) {
                if (Math.abs(this.zoomValue - 0.2) < Number.EPSILON) return;
                let newZoom = parseFloat((this.zoomValue - 0.2).toFixed(1));
                this.zoomFunc(e, newZoom);
            },
            tempZoomReset(e) {
                this.zoomFunc(e, 1);
            },
            zoomFunc(e, newZoom) {
                let container = this.$refs.previewArea;
                if (!container) return;
                let availWidth = container.clientWidth;
                let availHeight = container.clientHeight;

                let svg = container.children[0];
                let width = parseFloat(svg.style.width); // 初始宽度
                let height = parseFloat(svg.style.height);

                let visibleWidth = width * this.zoomValue; //实际宽度
                let visibleHeight = height * this.zoomValue;
                let left = availWidth > visibleWidth ? (availWidth - visibleWidth) / 2 : 0;
                let top = availHeight > visibleHeight ? (availHeight - visibleHeight) / 2 : 0;
                let originX = e ? e.offsetX : availWidth / 2;
                let originY = e ? e.offsetY : availHeight / 2;
                let mouseX = originX - left;
                let mouseY = originY - top;

                let xToCenter = (mouseX - (availWidth / 2 + this.xOffset)) / this.zoomValue;
                let yToCenter = (mouseY - (availHeight / 2 + this.yOffset)) / this.zoomValue;

                this.zoomValue = newZoom;
                if (width * newZoom > availWidth && height * newZoom > availHeight) {
                    let xOffset = xToCenter * this.zoomValue;
                    let yOffset = yToCenter * this.zoomValue;
                    let visX = availWidth / 2 + xOffset;
                    let visY = availHeight / 2 + yOffset;
                    this.xOffset = originX - visX;
                    this.yOffset = originY - visY;
                    if ((width * this.zoomValue) / 2 - availWidth / 2 - this.xOffset < 0) {
                        this.xOffset = (width * this.zoomValue) / 2 - availWidth / 2;
                    }
                    if ((height * this.zoomValue) / 2 - availHeight / 2 - this.yOffset < 0) {
                        this.yOffset = (height * this.zoomValue) / 2 - availHeight / 2;
                    }
                    if ((width * this.zoomValue) / 2 - availWidth / 2 + this.xOffset < 0) {
                        this.xOffset = -((width * this.zoomValue) / 2 - availWidth / 2);
                    }
                    if ((height * this.zoomValue) / 2 - availHeight / 2 + this.yOffset < 0) {
                        this.yOffset = -((height * this.zoomValue) / 2 - availHeight / 2);
                    }
                } else {
                    this.xOffset = 0;
                    this.yOffset = 0;
                }
                svg.style.transform = `scale(${this.zoomValue}) translate(${this.xOffset / this.zoomValue}px,${this.yOffset / this.zoomValue}px)`;
                let input = document.getElementById("zoomBar");
                input && input.style.setProperty("background-size", `${(this.zoomValue / 10) * 100}% 100%`);
                let text = document.getElementById("zoomText");
                let boxOffsetX = text ? text.clientWidth / 2 : 0;
                let sliderOffset = 10 / 2;
                text &&
                    (text.style.left = `${
                        44 + ((this.zoomValue - 0.02) / 9.98) * 120 - boxOffsetX - (sliderOffset * (this.zoomValue - 0.02)) / 9.98
                    }px`);
            },
            recXEvent() {
                let container = this.$refs.previewArea;
                if (!container) return;
                let availWidth = container.clientWidth;
                let availHeight = container.clientHeight;

                let svg = container.children[0];
                let width = parseFloat(svg.style.width); // 初始宽度
                let height = parseFloat(svg.style.height);
                if (width * this.zoomValue < availWidth) {
                    this.xOffset = 0;
                } else {
                    if ((width * this.zoomValue) / 2 - availWidth / 2 - this.xOffset < 0) {
                        console.log("left");
                        this.xOffset = (width * this.zoomValue) / 2 - availWidth / 2;
                    }
                    if ((width * this.zoomValue) / 2 - availWidth / 2 + this.xOffset < 0) {
                        console.log("right");
                        this.xOffset = -((width * this.zoomValue) / 2 - availWidth / 2);
                    }
                }
                if (height * this.zoomValue < availHeight) {
                    if (this.yOffset < 0) {
                        this.downPage();
                    } else {
                        this.upPage();
                    }
                    this.yOffset = 0;
                } else {
                    if ((height * this.zoomValue) / 2 - availHeight / 2 - this.yOffset < 0) {
                        this.yOffset = (height * this.zoomValue) / 2 - availHeight / 2;
                        this.upPage();
                    }
                    if ((height * this.zoomValue) / 2 - availHeight / 2 + this.yOffset < 0) {
                        this.yOffset = -((height * this.zoomValue) / 2 - availHeight / 2);
                        this.downPage();
                    }
                }
                svg.style.transform = `scale(${this.zoomValue}) translate(${this.xOffset / this.zoomValue}px,${this.yOffset / this.zoomValue}px)`;
            },
            getSvg() {
                if (this.getingSvg) return;
                this.getingSvg = true;
                let url = window["GLOBAL"].PUBLIC_OSS_HOST + this.work.url;
                let headers = {};
                if (this.type == "review" || this.type == "report") headers = { "cache-control": "no-cache" };

                axios
                    .get(url + "main.svg" + `?t=${Math.round(new Date().getTime() / 1000)}`, {
                        headers,
                    })
                    .then((e) => {
                        let data = e.data;
                        let domP = new DOMParser();
                        let svg = domP.parseFromString(data, "text/xml").children[0];
                        let svgChild = svg.children;
                        let defsEle;
                        let styleEle;
                        if (this.isSymbol) {
                            let width = svg.getAttribute("width"),
                                height = svg.getAttribute("height");
                            svg.setAttributeNS(null, "viewBox", `0 0 ${width} ${height}`);
                            this.pageDatas.push({
                                width: width,
                                height: height,
                                name: "",
                                html: svg,
                            });
                        } else {
                            for (let i = 0; i < svgChild.length; i++) {
                                if (svgChild[i].tagName === "defs") {
                                    defsEle = svgChild[i];
                                } else if (svgChild[i].tagName === "style") {
                                    styleEle = svgChild[i];
                                } else if (svgChild[i].tagName === "g") {
                                    let width = svgChild[i].children[0].getAttribute("width");
                                    let height = svgChild[i].children[0].getAttribute("height");
                                    // let trans = svgChild[i]
                                    //     .getAttribute("transform")
                                    //     .match(/\((.*)\,(.*)\)/);
                                    svgChild[i].removeAttribute("transform");
                                    let newPage = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                                    newPage.style = "pointer-events:none";
                                    newPage.setAttributeNS("http://www.w3.org/2000/svg", "xlink", "http://www.w3.org/1999/xlink");
                                    let name = svgChild[i].getAttribute("ed:name");

                                    if (styleEle) {
                                        newPage.appendChild(styleEle);
                                        i--;
                                        styleEle = null;
                                    }
                                    if (defsEle) {
                                        newPage.appendChild(defsEle);
                                        i--;
                                        defsEle = null;
                                    }
                                    newPage.appendChild(svgChild[i]);
                                    newPage.setAttributeNS(null, "viewBox", `0 0 ${width} ${height}`);

                                    this.pageDatas.push({
                                        width,
                                        height,
                                        name,
                                        html: newPage,
                                    });
                                    i--;
                                }
                            }
                        }

                        this.$nextTick(() => {
                            this.getingSvg = false;
                            this.$refs.previewLeft.forEach((div, index) => {
                                div.children[1].appendChild(this.pageDatas[index].html);
                            });
                            this.showRightSVG(0);
                        });
                        this.showMask = false;

                        if (this.isPC) {
                            let tType = this.work.price > 0 ? "communityPaid" : this.work.member_free ? "communityVip" : "communityFree";
                            this.$pcTrack(
                                JSON.stringify({
                                    type: "openFileProcess",
                                    action: "previewCommunityTemplate",
                                    event: "experience",
                                    label: JSON.stringify({
                                        template_type: tType,
                                    }),
                                })
                            );
                        }
                    });
            },
            showPre() {
                this.showPageNum = 0;
            },
            showRightSVG(index) {
                let dom = this.$refs.previewArea;
                while (dom.lastChild) {
                    dom.removeChild(dom.lastChild);
                }
                dom.appendChild(this.pageDatas[index].html.cloneNode(true));
            },
            upPage() {
                let count = this.showPageNum;
                count = count - 1 < 0 ? 0 : count - 1;
                this.showPageNum = count;
            },
            downPage() {
                let maxPage = this.pageDatas.length - 1;
                let count = this.showPageNum;
                count = count + 1 > maxPage ? maxPage : count + 1;
                this.showPageNum = count;
            },
            dragZoom(e) {
                let input = e.target;
                let val = input.value - 0;
                this.zoomValue = val;
                let svg = this.$refs.previewArea?.children[0];
                if (svg) {
                    svg.style.transform = `scale(${this.zoomValue})`;
                }
                input.style.setProperty("background-size", `${(val / 10) * 100}% 100%`);
                let text = document.getElementById("zoomText");
                let boxOffsetX = text ? text.clientWidth / 2 : 0;
                let sliderOffset = 10 / 2;
                text &&
                    (text.style.left = `${
                        44 + ((this.zoomValue - 0.02) / 9.98) * 120 - boxOffsetX - (sliderOffset * (this.zoomValue - 0.02)) / 9.98
                    }px`);
            },
            zoomUp() {
                if (Math.abs(this.zoomValue - 10) < Number.EPSILON) return;
                this.zoomValue = parseFloat((this.zoomValue + 0.2).toFixed(1));
                let svg = this.$refs.previewArea?.children[0];
                if (svg) {
                    svg.style.transform = `scale(${this.zoomValue})`;
                }
                let input = document.getElementById("zoomBar");
                input && input.style.setProperty("background-size", `${(this.zoomValue / 10) * 100}% 100%`);
                let text = document.getElementById("zoomText");
                let boxOffsetX = text ? text.clientWidth / 2 : 0;
                let sliderOffset = 10 / 2;
                text &&
                    (text.style.left = `${
                        44 + ((this.zoomValue - 0.02) / 9.98) * 120 - boxOffsetX - (sliderOffset * (this.zoomValue - 0.02)) / 9.98
                    }px`);
            },
            zoomDown() {
                if (Math.abs(this.zoomValue - 0.2) < Number.EPSILON) return;
                this.zoomValue = parseFloat((this.zoomValue - 0.2).toFixed(1));
                let svg = this.$refs.previewArea?.children[0];
                if (svg) {
                    svg.style.transform = `scale(${this.zoomValue})`;
                }
                let input = document.getElementById("zoomBar");
                input && input.style.setProperty("background-size", `${(this.zoomValue / 10) * 100}% 100%`);
                let text = document.getElementById("zoomText");
                let boxOffsetX = text ? text.clientWidth / 2 : 0;
                let sliderOffset = 10 / 2;
                text &&
                    (text.style.left = `${
                        44 + ((this.zoomValue - 0.02) / 9.98) * 120 - boxOffsetX - (sliderOffset * (this.zoomValue - 0.02)) / 9.98
                    }px`);
            },

            // zoom() {
            //     let value = this.zoomValue;

            //     for (let i = 0; i < this.pageDatas.length; i++) {
            //         let previewSvg = this.$refs.previewSvg[i];
            //         let svgEle = previewSvg.firstElementChild;
            //         if (!svgEle) continue;
            //         let width = this.pageDatas[i].width * value;
            //         let height = this.pageDatas[i].height * value;

            //         let previewArea = this.$refs.previewArea;
            //         let areaH = previewArea.offsetHeight,
            //             areaW = previewArea.offsetWidth;
            //         let centerpoint = {
            //             x: previewArea.scrollLeft + areaW / 2,
            //             y: previewArea.scrollTop + areaH / 2
            //         };

            //         svgEle.setAttribute("width", width);
            //         svgEle.setAttribute("height", height);
            //         this.changeSvgPosition(i);

            //         previewArea.scrollLeft = centerpoint.x - areaW / 2;
            //         previewArea.scrollTop = centerpoint.y - areaH / 2;
            //     }
            // },
            //预览svg时的拖动
            startDrag(e) {
                let pa = this.$refs.previewArea;
                this.dragInfo.isDrag = true;
                // this.dragInfo.startX = e.clientX;
                // this.dragInfo.startY = e.clientY;
                // this.dragInfo.startScrollLeft = pa.scrollLeft;
                // this.dragInfo.startScrollTop = pa.scrollTop;
            },
            dragging(e) {
                if (!this.dragInfo.isDrag) return;
                let xOffset = e.movementX;
                let yOffset = e.movementY;
                this.xOffset += xOffset;
                this.yOffset += yOffset;
                this.recXEvent();
            },
            endDrag() {
                this.dragInfo.isDrag = false;
            },
            //举报
            report() {
                // WsTrack('Community', "Report");
                // this.$track("Community", "Report");
                if (!this.$validateLogin()) return;
                // this.showReportReason = true;
                this.$bus.$emit("setReportAlertValue", true, this.work, this.params);
            },
            // doReport() {
            //     this.$refs.form.validate(pass => {
            //         if (!pass) {
            //             this.loading = false;
            //             this.$nextTick(() => {
            //                 this.loading = true;
            //             });
            //             return;
            //         }
            //         let reason = this.params.id + ": " + this.form.reportReason;
            //         this.$edApi
            //             .viewOrReportWork(
            //                 Object.assign(
            //                     {
            //                         workId: this.work.id,
            //                         report: reason,
            //                         report_type: this.form.reportRadio
            //                     },
            //                     this.params
            //                 )
            //             )
            //             .then(() => {
            //                 this.$edMessage.success(this.$t("message.reportSuccess"));
            //                 this.showReportReason = false;
            //                 this.form.reportReason = '';
            //                 this.form.reportRadio = 3;
            //             }).catch((e) =>{
            //                 this.showReportReason = false;
            //                 this.form.reportReason = '';
            //                 this.form.reportRadio = 3;
            //                 if(e.msg == 'Too many requests'){
            //                     this.$edMessage.error(this.$t("message.reportOnce"));
            //                 }
            //             });
            //     })
            // },
            // cancelReport() {
            //     this.form.reportReason = '';
            //     this.form.reportRadio = 3;
            // },
            //点赞或取消赞
            like(id) {
                // WsTrack("Community", "Like");
                // this.$track("Community", "Like");
                if (!this.$validateLogin()) return;
                if (this.doingLike) return;
                this.doingLike = true;
                let para = JSON.parse(JSON.stringify(this.params));
                if (this.hasLiked) {
                    //取消点赞
                    this.$edApi
                        .likeOrCollectWork(
                            Object.assign(para, {
                                workId: id,
                                like: 0,
                            })
                        )
                        .then(() => {
                            this.$bus.$emit("updateWorkIds", { id, type: "dislike" });
                            this.$bus.$emit("updateWorkIds2", { id, type: "dislike" });
                            this.doingLike = false;
                        });
                } else {
                    //点赞
                    this.$edApi
                        .likeOrCollectWork(
                            Object.assign(para, {
                                workId: id,
                                like: 1,
                            })
                        )
                        .then(() => {
                            this.$bus.$emit("updateWorkIds", { id, type: "like" });
                            this.$bus.$emit("updateWorkIds2", { id, type: "like" });
                            this.doingLike = false;
                            if (this.isPC) {
                                this.$pcTrack(
                                    JSON.stringify({
                                        type: "publish template",
                                        action: "likeTemplate",
                                        event: "experience",
                                    })
                                );
                            }
                        });
                }
                this.$bus.$emit("actionToWork", { type: "like", id, from: "tplpreview" });
            },
            //收藏或取消收藏
            collect() {
                // WsTrack("Community", "Collect");
                // this.$track("Community", "Collect");
                if (!this.$validateLogin()) return;
                if (this.doingCollect) return;
                this.doingCollect = true;
                let id = this.work.id;
                let para = JSON.parse(JSON.stringify(this.params));
                if (this.hasCollected) {
                    // 取消收藏
                    this.$edApi
                        .likeOrCollectWork(
                            Object.assign(para, {
                                workId: id,
                                collect: 0,
                            })
                        )
                        .then(() => {
                            this.$bus.$emit("updateWorkIds", { id, type: "discollect" });
                            this.$bus.$emit("updateWorkIds2", { id, type: "discollect" });
                            this.doingCollect = false;
                        });
                } else {
                    // 收藏
                    this.$edApi
                        .likeOrCollectWork(
                            Object.assign(para, {
                                workId: id,
                                collect: 1,
                            })
                        )
                        .then(() => {
                            // 首次操作时弹窗提示
                            if (!localStorage.getItem("checkCollect")) {
                                localStorage.setItem("checkCollect", "true");
                                this.$store.commit("setState", {
                                    type: "collectModal",
                                    data: true,
                                });
                            }
                            this.$bus.$emit("updateWorkIds", { id, type: "collect" });
                            this.$bus.$emit("updateWorkIds2", { id, type: "collect" });
                            this.doingCollect = false;
                        });
                }
                this.$bus.$emit("actionToWork", { type: "collect", id, from: "tplpreview" });
            },
            // 添加最近记录
            addTemplateRecent(id) {
                if (!this.$validateLogin()) return;
                this.$edApi
                    .addTemplateHistory({
                        user_id: this.userInfo.user_id,
                        token: this.userInfo.token,
                        data: {
                            template_id: id,
                            template_from: "COMMUNITY",
                        },
                    })
                    .then((e) => {
                        console.log("add subclass recent", e);
                        // this.initRecentData();
                    });
            },
            //克隆
            toVip() {
                const suffix = "iscommunity=1";
                if (this.isPC) {
                    this.pcBuyFlag = true;
                    this.userInfo.islogin &&
                        window.$qt.jsCallUpdateUpgradeTrigger &&
                        window.$qt.jsCallUpdateUpgradeTrigger("pay template in community");
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "upgradeSuffix",
                        data: "iscommunity=1",
                    });
                }
                let triggerName = this.work.member_free ? "cummunityVipTemplate" : "cummunityPayTemplates";
                this.$openBuyPage(triggerName, suffix);
            },
            clone() {
                this.$bus.$emit("doClone");
            },
            //下载作品
            downloadWork() {
                let fileKey = this.work.path,
                    exp = this.work.exp,
                    sign = this.work.sign;

                let ossParams = {
                    url: fileKey,
                    exp: exp,
                    sign: sign,
                    responseType: "blob",
                };
                this.$edApi.downloadOSSFile(ossParams).then((res) => {
                    saveAs(res.data, this.work.title + ".eddx");
                });
            },

            fullScreen() {
                let rootEle = this.$refs.previewBox;
                if (rootEle.requestFullscreen) {
                    rootEle.requestFullscreen();
                } else if (rootEle.webkitRequestFullscreen) {
                    rootEle.webkitRequestFullscreen();
                } else if (rootEle.mozRequestFullScreen) {
                    rootEle.mozRequestFullScreen();
                } else if (rootEle.msRequestFullscreen) {
                    rootEle.msRequestFullscreen();
                }
                document.addEventListener("mousemove", this.showToolFuc);
            },
            endFullScreen() {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozExitFullScreen) {
                    document.mozExitFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            },
            showToolFuc(e) {
                let fullEle = document.fullscreenElement || document.webkitFullscreenElement;
                if (fullEle != null) {
                    if (window.innerHeight - e.pageY < 200) {
                        this.showTools = true;
                    } else {
                        this.showTools = false;
                    }
                }
            },
            fullScreenEvent() {
                let fullEle = document.fullscreenElement || document.webkitFullscreenElement;
                if (fullEle) {
                    this.fullScreenFlag = true;
                } else {
                    this.fullScreenFlag = false;
                    this.showTools = false;
                    this.switchPrePages(0);
                    this.tempZoomReset();
                    document.removeEventListener("mousemove", this.showToolFuc);
                }
            },
            checkFirstVip() {
                if (!EDRAWMAX_PRODUCT_VIPLIMIT) return;
                if (!this.internal) return;
                // console.log("check vipppppppppppppppppfirst");
                this.$edApi
                    .getVipFirst({
                        id: this.params.id,
                        token: this.params.token,
                    })
                    .then((res) => {
                        let status = res.status;
                        if (status == "success") {
                            this.vipFirstFlag = true;
                        } else {
                            if (res.data.used == 0) {
                                this.showVipFirstTip = true;
                            } else {
                                this.showVipFirstTip = false;
                            }
                            this.vipFirstFlag = false;
                        }
                    });
            },
            cloneWorkWithFirstVip() {
                if (!this.internal) return;
                this.$edApi
                    .useVipFirst({
                        id: this.params.id,
                        token: this.params.token,
                        work_id: this.work.id,
                    })
                    .then((flag) => {
                        if (flag) {
                            this.vipFirstFlag = false;
                            this.$store.dispatch("getBoughtWorks").then(() => {
                                this.clone();
                            });
                        }
                    });
            },
        },
        mounted() {
            let rootEle = this.$refs.previewBox;
            rootEle.addEventListener("fullscreenchange", this.fullScreenEvent);
            if (this.userInfo) {
                if (!this.params.islogin) {
                    return;
                }
                let cloneVipTips = JSON.parse(localStorage.getItem("cloneVipTips"));
                this.cloneVipTips = !(cloneVipTips && cloneVipTips.includes(this.userInfo.user_id));
                console.log("cloneVipTips---", this.cloneVipTips);
            }
        },
        beforeDestroy() {
            this.$bus.$off("closePreview");
            this.$bus.$off("loginSucc-preview");
            window.removeEventListener("resize", this.resizeEvent);
            window.removeEventListener("keydown", this.togglePreEvent);
            let rootEle = this.$refs.previewBox;
            rootEle.removeEventListener("fullscreenchange", this.fullScreenEvent);
        },
    };
</script>
